import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useRedeemStf = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");

  const redeemStf = async (body: any) => await makeApiRequest(`${apiBase}/api/share-the-fair/transactions`, body);

  return [redeemStf];
};

export default useRedeemStf;
